/**
 * 每个页面顶部提示
 * 1. 每次请求都是返回所有页面的 提示信息
 * 2. 每 5分钟重新发起请求.
 * 3. 同一次登录态中, 用户手动关闭提示后， 不再展示提示信息。
 *    用户退出后, 重新登录, 信息也要重新展示.
 */
import { LANGUAGE_EN } from "@home/_config/config";
import FormatHtmlTextToReact from "@home/components/FormatHtmlTextToReact";
import classNames from "classnames";
import React, {useEffect, useState} from "react";
import { Alert, List } from "tea-component";
import { useIntl } from "umi";

function NoticeAlert(props: any) {
  const { infos, onClose, isClose, className, style } = props;
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const [visible, setVisible] = useState(infos.length > 0 && !isClose);

  useEffect(() => {
    setVisible(infos.length > 0 && !isClose);
  }, [infos, isClose]);

  return (
    <Alert
      type="info"
      visible={visible}
      onClose={() => {
        setVisible(false);
        onClose?.();
      }}
      hideIcon={infos.length > 1}
      style={{ marginBottom: "10px", ...style }}
      className={classNames("dbh-notice-alert", className)}
    >
      {infos.length === 1 ? (
        <FormatHtmlTextToReact text={isEn ? infos[0].en : infos[0].cn} />
      ) : (
        <List type="bullet">
          {infos.map((info: any, index: number) => (
            <List.Item key={index}>
              <FormatHtmlTextToReact text={isEn ? info.en : info.cn} />
            </List.Item>
          ))}
        </List>
      )}
    </Alert>
  );
}

export default NoticeAlert;
